import { NavLink } from "react-router";

/** 채널 화면 위의 메시지 | 보드 | 위키 탭 */
export function ChannelTabs({ channelId }: { channelId: number }) {
  return (
    <nav className="channel-tabs" aria-label="메시지·보드·위키">
      <NavLink to={`/c/${channelId}`} end>
        메시지
      </NavLink>
      <NavLink to={`/c/${channelId}/board`}>보드</NavLink>
      <NavLink to={`/c/${channelId}/wiki`}>위키</NavLink>
    </nav>
  );
}
